import React from 'react';

import { AddListingToTourModalContextProvider } from './AddListingToTourModalContext';

import { OnboardingWelcomeModalContextProvider } from './OnboardingWelcomeModalContext';

import { SetupBrokerageWizardModalContextProvider } from './SetupBrokerageWizardModalContext';

import { OnboardingPreLaunchModalContextProvider } from './OnboardingPreLaunchModalContext';

import { UserSuggestedUpdateModalContextProvider } from './UserSuggestedUpdateModalContext';

import { FeedbackModalContextProvider } from './FeedbackModalContext';

import { AppointmentActionModalContextProvider } from './AppointmentActionModalContext';

import { UserSuggestedEmailModalContextProvider } from './UserSuggestedEmailModalContext';

export const GlobalModalContextProvider: React.FC = ({ children }) => (
  <OnboardingPreLaunchModalContextProvider>
    <SetupBrokerageWizardModalContextProvider>
      <OnboardingWelcomeModalContextProvider>
        <UserSuggestedEmailModalContextProvider>
          <UserSuggestedUpdateModalContextProvider>
            <FeedbackModalContextProvider>
              <AppointmentActionModalContextProvider>
                <AddListingToTourModalContextProvider>
                  {children}
                </AddListingToTourModalContextProvider>
              </AppointmentActionModalContextProvider>
            </FeedbackModalContextProvider>
          </UserSuggestedUpdateModalContextProvider>
        </UserSuggestedEmailModalContextProvider>
      </OnboardingWelcomeModalContextProvider>
    </SetupBrokerageWizardModalContextProvider>
  </OnboardingPreLaunchModalContextProvider>
);
